//const { ObjectId } = require('bson')
const Joi = require('joi-browser')
//const JoiObjectId = require('joi-mongodb-objectid')
//const Joi = JoiBase.extend(JoiObjectId)

const parametersSchema = {
  _id: Joi.any(),
  name: Joi.string(),
  values: Joi.array().items(Joi.string())
};

exports.email = (email) => {
  var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

exports.product = (product, field) => {

  let slugJoi = Joi.string().required();
  let activeJoi = Joi.boolean().required();
  if(field === "for_insert") {
    slugJoi = Joi.string();
    activeJoi = Joi.boolean();
  }

  const schema = {
    _id: Joi.any(),
    name: Joi.string().min(3).max(200).required(),
    description: Joi.string().required(),
    price: Joi.number().min(0).required(),
    images: Joi.array().items(Joi.string().required()).required(),
    categories: Joi.array().min(1).required().items(Joi.any()),
    parameters: Joi.array().items(Joi.object(parametersSchema)),
    discount: Joi.number().min(0).max(100).invalid(0),
    slug: slugJoi,
    active: activeJoi,
    size: Joi.number().min(1).max(100)
  };

  if (typeof field === "undefined" || field === "for_insert") {

    if (Joi.validate(product, Joi.object().keys(schema)).error === null) {

      return true;

    } else {
      return false;

    }
  } else {

    if (Joi.validate(product, schema[field]).error === null) {
      return true;
    } else {
      return false;
    }

  }
}

exports.category = (category, field) => {

  let slugJoi = Joi.string().required();
  if(field === "for_insert") {
    slugJoi = Joi.string();
  }

  const schema = Joi.object().keys({
    _id: Joi.any(),
    name: Joi.string().min(3).max(30).required(),
    slug: slugJoi,
    parent: Joi.any()});

  if (Joi.validate(category, schema).error === null) {
    return true;
  } else {
    //console.log(category);
    return false;
  }

}
exports.info = (info, field) => {

  const schema = {
    _id: Joi.any(),
    name: Joi.string().min(3).max(100).required(),
    city: Joi.string().min(3).max(100).required(),
    street: Joi.string().min(3).max(300).required(),
    postalCode: Joi.number().min(10000).max(99999).required(),
    ico: Joi.number().required(),
    dic: Joi.string().min(3).max(30).required(),
    tel: Joi.string().min(9).max(30).required(),
    email: Joi.string().required()
  };

  if (typeof field === "undefined" || field === "for_insert") {

    if (Joi.validate(info, Joi.object().keys(schema)).error === null) {

      return true;

    } else {
      return false;

    }
  } else {

    if (Joi.validate(info, schema[field]).error === null) {
      return true;
    } else {
      return false;
    }

  }

}

exports.article = (article, field) => {

  const schema = {
    _id: Joi.any(),
    name: Joi.string().min(3).max(100).required(),
    article: Joi.string().min(10).required(),
    slug: Joi.string().min(3).max(300)
  };

  if (typeof field === "undefined" || field === "for_insert") {

    if (Joi.validate(article, Joi.object().keys(schema)).error === null) {

      return true;

    } else {
      return false;

    }
  } else {

    if (Joi.validate(article, schema[field]).error === null) {
      return true;
    } else {
      return false;
    }

  }

}

exports.user = (userToCheck, field, isAddress) => {

  const address = {
    city: Joi.string().min(3).max(100).required(),
    street: Joi.string().min(1).max(300).required(),
    postalCode: Joi.number().min(10000).max(99999).required(),
    country: Joi.string().min(1).max(100).required()
  };

  const user = {
    _id: Joi.any(),
    name: Joi.string().min(3).max(30).required(),
    surname: Joi.string().min(3).max(30).required(),
    email: Joi.string().required(),
    password: Joi.string().required(),
    role: Joi.string().valid("user", "admin"),
    address: Joi.object(address).required()
  }

  const schema = Joi.object().keys(user);

  if (typeof field === "undefined" && typeof isAddress === "undefined") {
    if (Joi.validate(userToCheck, schema).error === null) {
      return true;
    } else {
      return false;
    }

  } else if (isAddress === true) {

    if (Joi.validate(userToCheck, address[field]).error === null) {

      return true;
    } else {
      return false;
    }

  } else {

    if (Joi.validate(userToCheck, user[field]).error === null) {
      return true;
    } else {
      return false;
    }
  }
}

exports.parameter = (parameter) => {

  if (Joi.validate(parameter, parametersSchema).error === null) {
    return true;
  } else {
    //console.log(product);
    //console.log(Joi.validate(product, schema).error);
    return false;
  }

}

exports.shippingPayment = (item, field) => {

  const schema = {
    _id: Joi.any(),
    name: Joi.string().min(3).max(50).required(),
    price: Joi.number().min(0).required(),
    free: Joi.number().min(0).required(),
    description: Joi.string().min(3).max(300),
    payment: Joi.array().items(Joi.string())
  };

  if (typeof field === "undefined" || field === "for_insert") {

    if (Joi.validate(item, Joi.object().keys(schema)).error === null) {
      return true;
    } else {
      return false;
    }
  } else {

    if (Joi.validate(item, schema[field]).error === null) {
      return true;
    } else {
      return false;
    }

  }

}



// WEBPACK FOOTER //
// ./src/lib/validate.js